import React from 'react';

import { licensePermissionChecks } from '../../../utils/permission-check/license';
import { useDialog } from '../../hooks/use-dialog';
import { useProjectSnapshot } from '../../hooks/use-project-snapshot';
import { BuyDesignLicenseDialog } from '../buy-design-license-dialog/buy-design-license-dialog';
import { DesignLicenseAddedInfoDialog } from '../design-license-added-info-dialog/design-license-added-info-dialog';
import { DesignLicenseExpiredDialog } from '../design-license-expired-dialog/design-license-expired-dialog';

export const DesignLicenseExpiredNotificationDialog = (props: { onClose: () => void }) => {
  const { projectId } = useProjectSnapshot();
  const designLicenseExpiredDialog = useDialog(true);
  const buyDesignLicenseDialog = useDialog();
  const designLicenseAddedInfoDialog = useDialog();
  const expiredLicense = licensePermissionChecks.getExpiredLicense('DESIGN');

  return (
    <>
      {designLicenseExpiredDialog.render(
        <DesignLicenseExpiredDialog
          expiredLicense={expiredLicense}
          onBuyButtonClicked={() => {
            buyDesignLicenseDialog.show();
            designLicenseExpiredDialog.hide();
          }}
          onClose={props.onClose}
        />,
      )}

      {expiredLicense && projectId && (
        <>
          {buyDesignLicenseDialog.render(
            <BuyDesignLicenseDialog
              license={expiredLicense}
              projectId={projectId}
              onClose={() => {
                buyDesignLicenseDialog.hide();
                props.onClose();
              }}
              onFormSubmitted={() => {
                designLicenseAddedInfoDialog.show();
                designLicenseExpiredDialog.hide();
                buyDesignLicenseDialog.hide();
              }}
            />,
          )}

          {designLicenseAddedInfoDialog.render(
            <DesignLicenseAddedInfoDialog license={expiredLicense} />,
          )}
        </>
      )}
    </>
  );
};
